import styled from '@emotion/styled';
import css from '@emotion/css';
import { borderRadii } from 'app/spacing';
import Button from 'components/Button';
import Select from 'components/Inputs/Select';
import { KizenTypography } from 'app/typography';
import IconButton from 'components/Kizen/IconButton';
import Card from 'components/Card/Card';

export const StyledMatchingCard = styled(Card)`
  padding: 20px;
  padding-bottom: 15px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 1372px;
  min-height: 323px;
`;

export const StyledAddActionButton = styled(Button)`
  margin: 0;
  padding: 0;
  height: fit-content;
`;

export const StyledActionsList = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
  &:not(:empty) {
    margin-bottom: 17px;
  }
`;

export const StyledActionWarpper = styled.div`
  width: 100%;
  display: flex;
  padding: 15px;
  padding-bottom: 20px;
  margin-bottom: ${({ isLastExecutableAction }) =>
    isLastExecutableAction ? 39 : 0}px;
  gap: 15px;
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? 'var(--color-button-warning-default)'
        : 'var(--color-border-medium)'};
  border-radius: ${borderRadii.small};
`;

export const StyledActionCard = styled.div`
  width: calc(100% - 37px);
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const StyledDiv = styled.div`
  ${({ width }) => css`
    width: ${width}px;
  `}
`;

export const StyledRow = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

export const StyledBoldSelect = styled(Select)`
  margin-top: 5px;
  & label {
    font-weight: 600;
  }
`;

export const StyledSubheader = styled(KizenTypography)`
  width: 100%;
  margin-top: 8px;
  margin-bottom: -3px;
`;

export const StyledRotatedButon = styled(IconButton)`
  transform: rotate(180deg);
`;

export const StyledReorderButtons = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

export const StyledDeleteButton = styled(Button)`
  margin: 0;
  margin-left: auto;
  padding: 0;
  height: fit-content;
`;

export const StyledPermissionSettings = styled.div`
  width: 100%;
`;
